import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _organisations = [];

const sanitise = ({id, departmentCount, ...rest}) => ({
    id: Number(id),
    departmentCount: departmentCount && Number(departmentCount),
    ...rest,
    accessGroupId: Number(rest.accessGroupId) || null,
});

var OrganisationStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _organisations.filter((e) => !!e);
    },
    getById: function(id) {
        id = Number(id);
        return _organisations.find((e) => !!e && e.id === id );
    },
    add: function(organisation) {
        organisation = sanitise(organisation);
        const index = _organisations.findIndex((e) => !!e && e.id === organisation.id );
        if (0 <= index) {
            _organisations[index] = organisation;
        } else {
            _organisations.push(organisation);
        }
    },
    remove: function(data) {
        const id = Number(data.id);
        let index = _organisations.findIndex((e) => !!e && e.id === id );
        if (0 <= index) {
            if (!!data.deleted) {
                delete _organisations[index];
            }
        }
    },

});

OrganisationStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.ORGANISATION_LIST:
            _organisations = action.data.map(sanitise);
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_LIST_ERROR:
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_INFO:
            OrganisationStore.add(action.data);
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_INFO_ERROR:
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_SAVE:
            OrganisationStore.add(action.data);
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_SAVE_ERROR:
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_UPDATE:
            OrganisationStore.add(action.data);
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_UPDATE_ERROR:
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_DEFAULT:
            action.data.forEach(OrganisationStore.add);
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_DEFAULT_ERROR:
            OrganisationStore.emitChange();
            break;

        case ActionTypes.ORGANISATION_DELETE:
            OrganisationStore.remove(action.data);
            OrganisationStore.emitChange();
            break;

        default:
            break;

    }

});

export default OrganisationStore;
